import script from "./BlogView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogView.vue?vue&type=script&setup=true&lang=js"

import "./BlogView.vue?vue&type=style&index=0&id=22325ecf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22325ecf"]])

export default __exports__